module.exports = __webpack_public_path__ + "img/banner.3dbbf2c.png";